import React from 'react';
import { useSiteContent, trackEvent } from '../context/SiteContext';
import './Location.css';

const Location = () => {
  const { settings } = useSiteContent();
  const phone = settings?.contactPhone || '+49 179 3912947';
  const email = settings?.contactEmail || 'event.service.woerth@gmail.com';

  const handleCallClick = () => { trackEvent('call_click'); };

  return (
    <section className="location section-padding">
      <div className="container">
        <div className="location-content grid-two-column">
          <div className="location-info">
            <h2 className="heading-1">
              Besuchen Sie uns
            </h2>
            <p className="body-large space-top-md">
              Unsere Eventlocation befindet sich in zentraler Lage in Wörth am Main. Gut erreichbar für Gäste aus der gesamten Region.
            </p>
            
            <div className="address-block space-top-xl">
              <h3 className="heading-3">Adresse</h3>
              <p className="body-regular space-top-sm">
                BD Event Location<br />
                Pfarrer-Adam-Haus-Strasse 6a<br />
                63939 Wörth am Main
              </p>
            </div>

            <div className="contact-block space-top-lg">
              <h3 className="heading-3">Kontakt</h3>
              <p className="body-regular space-top-sm">
                <a href={`tel:${phone}`} className="contact-link" onClick={handleCallClick} data-testid="location-phone">
                  Telefon: {phone}
                </a>
              </p>
              <p className="body-regular space-top-sm">
                <a href={`mailto:${email}`} className="contact-link" data-testid="location-email">
                  E-Mail: {email}
                </a>
              </p>
            </div>
          </div>

          <div className="map-container">
            <iframe
              title="BD Event Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2603.5!2d9.1494!3d49.7944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bd8e7c7c7c7c7c%3A0x7c7c7c7c7c7c7c7c!2sPfarrer-Adam-Haus-Stra%C3%9Fe%206a%2C%2063939%20W%C3%B6rth%20am%20Main!5e0!3m2!1sde!2sde!4v1234567890123!5m2!1sde!2sde"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;